import { createIdSlice } from '../utils/action/createElementSlice';
export const SelectionDisabledState = createIdSlice({
    elementName: 'selectiondisabled',
    initialState: {},
    reducers: {
        set: (_state, action) => {
            return action.payload.data;
        },
    },
});
